module.exports = __webpack_public_path__ + "static/media/img-boxfit-product-1@3x.697c8cc5.png";